import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 mb-3" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "boxTitle" }
const _hoisted_5 = { class: "mb-3 d-flex align-items-center justify-content-between" }
const _hoisted_6 = {
  key: 0,
  class: "midTitle"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["filter", "sort"]
const _hoisted_9 = ["filter"]
const _hoisted_10 = ["filter"]
const _hoisted_11 = ["filter", "sort"]
const _hoisted_12 = ["filter", "sort"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { colspan: "99" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!
  const _component_accordion = _resolveComponent("accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Prenotazioni ({{tickets}} disponibili, {{prenotazioni}} effettuate)",
                text: "Prenotazioni ({{tickets}} disponibili, {{prenotazioni}} effettuate)",
                object: { tickets: _ctx.tickets.length, prenotazioni: _ctx.prenotazioni.length }
              }, null, 8, ["object"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                (_ctx.tickets.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Hai una prenotazione a disposizione!",
                        text: "Hai una prenotazione a disposizione!"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.makePrenotazione && _ctx.makePrenotazione(...args))),
                disabled: _ctx.tickets.length <= 0
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Effettua prenotazione",
                  text: "Effettua prenotazione"
                })
              ], 8, _hoisted_7)
            ]),
            _createVNode(_component_op_table, {
              class: "table table-striped",
              items: _ctx.prenotazioni,
              filtersFn: _ctx.filtersFn,
              showUpperPagination: _ctx.useOpTable,
              showLowerPagination: _ctx.useOpTable
            }, {
              default: _withCtx((opData) => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      width: "80",
                      filter: _ctx.useOpTable ? 'data' : false,
                      sort: _ctx.useOpTable ? 'data' : false,
                      filterType: "date"
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Data",
                        text: "Data"
                      })
                    ], 8, _hoisted_8),
                    _createElementVNode("td", {
                      width: "100",
                      filter: _ctx.useOpTable ? 'user.name' : false
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Centro",
                        text: "Centro"
                      })
                    ], 8, _hoisted_9),
                    _createElementVNode("td", {
                      width: "100",
                      filter: _ctx.useOpTable ? 'fasciaOraria' : false
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Fascia oraria",
                        text: "Fascia oraria"
                      })
                    ], 8, _hoisted_10),
                    _createElementVNode("td", {
                      filter: _ctx.useOpTable ? 'note' : false,
                      sort: _ctx.useOpTable ? 'note' : false
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Note",
                        text: "Note"
                      })
                    ], 8, _hoisted_11),
                    _createElementVNode("td", {
                      filter: _ctx.useOpTable ? 'stato.value' : false,
                      sort: _ctx.useOpTable ? 'stato.value' : false
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Stato",
                        text: "Stato"
                      })
                    ], 8, _hoisted_12),
                    _hoisted_13
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (opData.items.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                        _createElementVNode("td", _hoisted_15, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Nessun elemento trovato",
                            text: "Nessun elemento trovato"
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.PrenotazioneForListVm[]), (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.data)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-link text-left",
                          onClick: ($event: any) => (_ctx.centroDetails(item.user))
                        }, [
                          _createElementVNode("u", null, _toDisplayString(item.user.name), 1)
                        ], 8, _hoisted_16)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Dalle",
                          text: "Dalle"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.from)) + " ", 1),
                        _createVNode(_component_localized_text, {
                          localizedKey: "alle",
                          text: "alle"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.to)), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.note), 1),
                      _createElementVNode("td", null, [
                        (item.stato)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(item.stato.value), 1),
                              _hoisted_17,
                              _createTextVNode("(" + _toDisplayString(_ctx.$filters.date(item.stato.date, "YYYY-MM-DD HH:mm")) + ") ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        (item.stato.value != 'Concluso' && item.stato.value != 'Annullato' && item.stato.value != 'Respinto')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.$store.state.isAdmin())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-success",
                                    onClick: ($event: any) => (_ctx.concludiPrenotazione(item.identifier))
                                  }, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Concludi",
                                      text: "Concludi"
                                    })
                                  ], 8, _hoisted_18))
                                : _createCommentVNode("", true),
                              (_ctx.$store.state.isAdmin())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn btn-primary ml-2",
                                    onClick: ($event: any) => (_ctx.respingiPrenotazione(item.identifier))
                                  }, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Respingi",
                                      text: "Respingi"
                                    })
                                  ], 8, _hoisted_19))
                                : _createCommentVNode("", true),
                              (_ctx.$store.state.isAdmin())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "btn btn-warning ml-2",
                                    onClick: ($event: any) => (_ctx.spostaPrenotazione(item))
                                  }, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Sposta",
                                      text: "Sposta"
                                    })
                                  ], 8, _hoisted_20))
                                : _createCommentVNode("", true),
                              (_ctx.$store.state.isAdmin())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    type: "button",
                                    class: "btn btn-danger ml-2",
                                    onClick: ($event: any) => (_ctx.deletePrenotazione(item.identifier))
                                  }, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Annulla",
                                      text: "Annulla"
                                    })
                                  ], 8, _hoisted_21))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["items", "filtersFn", "showUpperPagination", "showLowerPagination"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}